module.exports = __webpack_public_path__ + "app/assets/images/man1-4df3befed542d04520b82d81ed719c87.jpg";